import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=033148b4"
import script from "./ModalHeader.ts?vue&type=script&lang=ts&external"
export * from "./ModalHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports